package it.neckar.lizergy.model.configuration.moduleLayout.planning

import com.meistercharts.charts.pv.roofPlanning.UnusableArea
import com.meistercharts.charts.pv.roofPlanning.UnusableAreas
import it.neckar.lizergy.model.configuration.moduleLayout.planning.UnusableAreaInformation.UnusableAreaId
import kotlinx.serialization.Serializable

/**
 * Contains a list of unusable areas
 */
@Serializable
data class UnusableAreasInformation(
  val unusableAreas: List<UnusableAreaInformation>
) {
  /**
   * Convert back to "live" unusableAreas
   */
  fun toUnusableAreas(): Iterable<UnusableArea> {
    return buildList {
      unusableAreas.map {
        UnusableArea(
          uuid = it.uuid,
          location = it.location,
          size = it.size,
          rightTriangleType = it.rightTriangleType,
        ).apply {
          description = it.description
        }
      }.let {
        addAll(it)
      }
    }
  }
}

fun UnusableAreas.toRestApiModel(): UnusableAreasInformation {
  return UnusableAreasInformation(
    unusableAreas.map {
      UnusableAreaInformation(
        id = UnusableAreaId(it.uuid),
        location = it.location,
        size = it.size,
        description = it.description,
        rightTriangleType = it.rightTriangleType,
      )
    }
  )
}
